import React from 'react';

interface HeaderButtonProps {
  onClick?: () => void;
  children: React.ReactNode;
}

export const HeaderButton: React.FC<HeaderButtonProps> = ({ onClick, children }) => {
  return (
    <button
      onClick={onClick}
      className="px-3 md:px-[32px] py-1.5 md:py-[16px] flex justify-center items-center cursor-pointer border-none outline-none focus:outline-none whitespace-nowrap"
      style={{ 
        background: '#C6A972',
        borderRadius: '8px',
        color: '#222222',
        fontSize: 'clamp(12px, 2.5vw, 16px)',
        fontWeight: '500',
        fontFamily: 'Figtree',
        lineHeight: '1',
        textTransform: 'uppercase'
      }}
    >
      {children}
    </button>
  );
};
